module.exports = __webpack_public_path__ + "img/pay-icon-7.b48581e0.png";